import { birthDateEN, birthDateNO } from 'constants/regex';
import dayjs from 'dayjs';
const isValidDate = (input, lang) => {
  // Don't validate if field is empty
  if (!input) return true;
  let regex = lang ? birthDateNO : birthDateEN;
  return regex.test(String(input).toLowerCase());
};
const isValidAge = (input, lang) => {
  if (!input) return true;
  let format = lang ? "DD.MM.YYYY" : "YYYY-MM-DD";
  return dayjs(input, format).isBefore(dayjs().subtract(18, 'year'));
};
export { isValidDate, isValidAge };